import React from 'react';
import styled from 'styled-components';

const StyledSuffixWrapper = styled.div`
  background-color: #fafafa;
  border-left-width: 0px;
  border-radius: 0px 4px 4px 0px;
  border: 1px solid #d9d9d9;
  padding: 3.3px 5px;
  pointer-events: none;
  text-align: center;
  width: 83px;
`;

export const Suffix: React.VFC<{ value: string }> = ({ value }) => <StyledSuffixWrapper>{value}</StyledSuffixWrapper>;
